var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 30,
    viewBox: "0 0 44 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.1899 0.896091C41.0842 1.39 42.573 2.83998 43.08 4.68508C43.9963 8.026 44 15.0007 44 15.0007C44 15.0007 44 21.9754 43.08 25.3164C42.573 27.1615 41.0842 28.6114 39.1899 29.1053C35.76 30.0014 21.9999 30.0014 21.9999 30.0014C21.9999 30.0014 8.24003 30.0014 4.81 29.1053C2.91571 28.6114 1.42707 27.1615 0.919986 25.3164C0 21.9754 0 15.0007 0 15.0007C0 15.0007 0 8.026 0.919986 4.68508C1.42707 2.83998 2.91571 1.39 4.81 0.896091C8.24003 0 21.9999 0 21.9999 0C21.9999 0 35.76 0 39.1899 0.896091ZM29.0268 15.0006L17.5958 21.4284V8.57266L29.0268 15.0006Z",
    fill: "#A8A1B2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.52181b5a1f9d038538576392196e3b6d.svg";
export { ForwardRef as ReactComponent };